import { Icon, StandardCard, Typography } from '@/components';
import { Skeleton } from '@/components/ui/skeleton';

type SellerAnalyticsProps = {
  readonly stats: {
    liveCount: number;
    eoisReceived: number;
    totalViews: number;
  };
  readonly isLoading?: boolean;
};

const ANALYTICS_ITEMS = [
  { key: 'liveCount', icon: 'briefcase-business', label: 'Opportunities Live' },
  { key: 'eoisReceived', icon: 'mail', label: 'EOIs Received' },
  { key: 'totalViews', icon: 'eye-open', label: 'Opportunity Views' },
] as const;

export function SellerAnalytics({ stats, isLoading }: SellerAnalyticsProps) {
  return (
    <StandardCard title="Seller Analytics" description="Track your opportunities performance">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        {ANALYTICS_ITEMS.map(({ key, icon, label }) => (
          <div
            key={key}
            className="bg-background border-border hover:border-primary-300 rounded-lg border p-3 transition-colors"
          >
            <div className="flex items-center gap-3 sm:block">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-neutral-50 sm:mb-3 sm:h-10 sm:w-10">
                <Icon name={icon} className="h-5 w-5 sm:h-6 sm:w-6" />
              </div>
              <div className="flex items-baseline gap-2 sm:block">
                {isLoading ? (
                  <>
                    <Skeleton className="h-8 w-12 sm:mb-1 sm:ml-1" />
                    <Skeleton className="mt-1 h-4 w-24 sm:ml-1" />
                  </>
                ) : (
                  <>
                    <div className="text-2xl font-bold sm:mb-1 sm:ml-1 sm:text-3xl">{stats[key]}</div>
                    <Typography as="p" size="body-3" className="text-muted-foreground sm:ml-1">
                      {label}
                    </Typography>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </StandardCard>
  );
}
